'use client';

import { createContext, useEffect, useState } from 'react';
import { useSites } from '@/entities/site/hooks/use-sites';
import { Site } from '@platform/shared';
import { useRouter } from 'next/navigation';

export interface SiteContextType {
  currentSite: Site | null | undefined;
  setCurrentSite: (siteId: string | null, url?: string) => void;
}

export const initialSiteContext: SiteContextType = {
  currentSite: undefined,
  setCurrentSite: () => logger.warn('Site context not ready yet for set value'),
};

export const SiteContext = createContext<SiteContextType>(initialSiteContext);

export const SiteProvider = ({ children }: { children: React.ReactNode }) => {
  const isLocalStorageExist = typeof localStorage !== 'undefined';
  const [currentSite, setCurrentSiteState] = useState<Site | null | undefined>(undefined);
  const [currentSiteId, setCurrentSiteId] = useState(isLocalStorageExist ? localStorage.getItem('siteId') : null);
  const { data: sites } = useSites();
  const router = useRouter();

  useEffect(() => {
    if (sites) {
      const savedCurrentSite = sites.find((site) => site.id === currentSiteId) ?? null;
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCurrentSiteState(savedCurrentSite);
    }
  }, [sites, currentSiteId]);

  const setCurrentSite = (siteId: string | null, url?: string) => {
    setCurrentSiteId(siteId);
    if (isLocalStorageExist && siteId) {
      localStorage.setItem('siteId', siteId);
    }
    if (isLocalStorageExist && !siteId) {
      localStorage.removeItem('siteId');
    }
    if (url) {
      router.push(url);
    } else {
      window.location.reload();
    }
  };

  return <SiteContext.Provider value={{ currentSite, setCurrentSite }}>{children}</SiteContext.Provider>;
};
